import {createRouter} from '@tanstack/react-router';
import {routeTree} from './routeTree.gen';
import {
  init,
  tanstackRouterBrowserTracingIntegration,
} from '@sentry/tanstackstart-react';
import {replayIntegration} from '@sentry/browser';

export function getRouter() {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
  });

  if (!router.isServer) {
    init({
      dsn: 'https://62a9a0aab8eeed306df7a512b846b6c3@o4509196340232192.ingest.de.sentry.io/4509196398166096',

      // Add optional integrations for additional features
      integrations: [
        replayIntegration(),
        tanstackRouterBrowserTracingIntegration(router),
      ],

      // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
      tracesSampleRate: 0.1,

      // Define how likely Replay events are sampled.
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.1,

      // Define how likely Replay events are sampled when an error occurs.
      replaysOnErrorSampleRate: 1.0,

      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: false,

      environment: import.meta.env.TRACING_ENV,

      beforeSend(event) {
        const exceptions = event.exception?.values;
        if (exceptions?.length !== 1) {
          return event;
        }

        const frames = exceptions[0].stacktrace?.frames;
        if (!frames || frames.length === 0) {
          return event;
        }

        if (frames[0].filename === 'app:///frame_ant/frame_ant.js') {
          // drop that garbage
          return null;
        }

        return event;
      },
    });
  }

  return router;
}
